import { getAccessToken } from './auth-token';
import { getImpersonatedEmiratesId } from '@/components/DebugBar';
import { IS_DEV } from './env';

async function jsonFetcher<T = unknown>(input: string, init?: RequestInit): Promise<T> {
  const res = await fetch(input, init);

  if (!res.ok) {
    let errorObj: any = { status: res.status, statusText: res.statusText };
    try {
      const text = await res.text();
      errorObj = JSON.parse(text);
    } catch {
      // fallback to status only
    }
    throw errorObj;
  }
  if (res.status === 204) {
    return null as T;
  }
  return (await res.json()) as T;
}

export async function authenticatedFetcher<T = unknown>(input: string, init?: RequestInit): Promise<T> {
  const token = getAccessToken();
  const isFormData = init?.body instanceof FormData;
  const headers: Record<string, string> = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...((init?.headers as Record<string, string>) || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (IS_DEV) {
    const impersonatedEmiratesId = getImpersonatedEmiratesId();
    if (impersonatedEmiratesId) {
      headers['X-Impersonate-EmiratesId'] = impersonatedEmiratesId;
    }
  }

  return jsonFetcher<T>(input, { ...init, headers });
}

export const defaultSWRConfig = {
  fetcher: jsonFetcher,
  revalidateOnFocus: false,
  shouldRetryOnError: true, // Enable retry for transient failures
  errorRetryCount: 3, // Retry up to 3 times
  errorRetryInterval: 2000, // Wait 2 seconds between retries
  dedupingInterval: 5000, // Prevent duplicate requests within 5 seconds
} as const;
